import React from "react";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { View } from "react-native";
import { MenuItem } from "./MenuItem";
import { SupportIcon } from "../icons/SupportIcon";
import { PrivacyIcon } from "../icons/PrivacyIcon";
import { GlobalStyles } from "../style/Style";
import { TermsIcon } from "../icons/TermsIcon";
import { SignOutIcon } from "../icons/SignOutIcon";
import { SignInIcon } from "../icons/SignInIcon";

interface ButtonProps {
    menuConfig: MenuConfig;
    loggedIn: boolean;
}

export type MenuConfig = {
    privacyOnPress: () => void;
    termsOnPress: () => void;
    supportOnPress: () => void;
    signInOnPress: () => void;
    signOutOnPress: () => void;
};

export const Menu: React.FC<ButtonProps> = ({ menuConfig, loggedIn }) => {
    const styles = useDynamicStyles(generateStyles);

    return (
        <View style={styles.menuContainer}>
            <MenuItem
                label={"Privacy Policy"}
                icon={<PrivacyIcon fill={EStyleSheet.value(GlobalStyles.BASE_COLOUR)} />}
                onPress={menuConfig.privacyOnPress}
            />
            <MenuItem
                label={"Terms & Conditions"}
                icon={<TermsIcon fill={EStyleSheet.value(GlobalStyles.BASE_COLOUR)} />}
                onPress={menuConfig.termsOnPress}
            />
            <MenuItem
                label={"Support"}
                icon={<SupportIcon fill={EStyleSheet.value(GlobalStyles.BASE_COLOUR)} />}
                onPress={menuConfig.supportOnPress}
            />
            {loggedIn ? (
                <MenuItem
                    label={"Sign Out"}
                    icon={<SignOutIcon fill={EStyleSheet.value(GlobalStyles.BASE_COLOUR)} />}
                    onPress={menuConfig.signOutOnPress}
                />
            ) : (
                <MenuItem
                    label={"Sign In"}
                    icon={<SignInIcon fill={EStyleSheet.value(GlobalStyles.BASE_COLOUR)} />}
                    onPress={menuConfig.signInOnPress}
                />
            )}
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        menuContainer: {
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
            padding: 20,
            paddingRight: 30,
            paddingTop: 0,
            position: "absolute",
            right: 5,
            top: 45,
            zIndex: 10000,
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            shadowColor: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            shadowOffset: {
                width: 0,
                height: 5,
            },
            shadowRadius: 8,
            shadowOpacity: 0.3,
        },
    });
};
